<template>
  <v-card height="24rem" color="background" class="d-flex align-center justify-center">
    <v-card-item>
      <v-row>
        <slot name="image" />
      </v-row>
      <v-row class="mx-10">
        <v-card-text class="text-grey-darken-1 text-body-2 pb-0 text-center">
          {{ mainText }}
        </v-card-text>
      </v-row>
      <v-row class="mx-10 my-n2">
        <v-card-text v-if="subText" class="text-grey-darken-1 text-body-2">
          {{ subText }}
        </v-card-text>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-btn
          :color="buttonColor"
          class="my-5"
          :prepend-icon="buttonIcon"
          @click="handleButtonClick"
        >
          {{ buttonText }}
        </v-btn>
      </v-row>
    </v-card-item>
  </v-card>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";

const props = defineProps({
  mainText: {
    type: String,
    required: true,
  },
  subText: {
    type: String,
    required: false,
  },
  buttonText: {
    type: String,
    required: true,
  },
  buttonColor: {
    type: String,
    default: "blue",
  },
  buttonIcon: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["button-click"]);

const handleButtonClick = () => {
  emits("button-click");
};
</script>
